module.exports = __webpack_public_path__ + "img/t2.961a1711.png";